module.exports = __webpack_public_path__ + "img/device_65les.bec42da9.png";